import { createSelector } from "@reduxjs/toolkit";
import { IStoreState } from "../../../../reducers/types";
import dayjs from "dayjs";
import { filterOutSpendAndGetOffers } from "halifax";

const getAllTravelWalletOffers = (state: IStoreState) =>
  state.vacationRentalTravelWallet.offers;

export const getTravelWalletOffers = createSelector(
  getAllTravelWalletOffers,
  (offers) => filterOutSpendAndGetOffers(offers)
);

export const getActiveTravelWalletOffers = createSelector(
  getTravelWalletOffers,
  (offers) => {
    return offers.filter((offer) => {
      return dayjs().isAfter(dayjs(offer?.saleEventStartOn));
    });
  }
);
export const getTravelWalletCredit = (state: IStoreState) =>
  state.vacationRentalTravelWallet.credit;

export const getCreditBreakdown = (state: IStoreState) =>
  state.vacationRentalTravelWallet.creditBreakdown;

export const getTravelCreditsHistoryTransaction = (state: IStoreState) =>
  state.vacationRentalTravelWallet.creditsHistoryTransactions;

export const getPartialHistoryValidFromTime = (state: IStoreState) =>
  state.vacationRentalTravelWallet.partialHistoryValidFromTime;
